import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useSelector } from "react-redux";
import { useRoutes } from "react-router-dom";
import "./App.css";
import { RTL } from "./layout/fullLayout/customizer/RTL";
import { ThemeSettings } from "./layout/fullLayout/customizer/ThemeSettings";
import { IStoreState } from "./redux/initialStoreState";
import { Router } from "./router/router";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TableProvider } from "./components/Table/contexts/TableProvider";
import {
  DataTableV2Provider,
  DataTableV2ProviderHandle,
} from "./components/TableV2/context/DataTableV2Provider";
import { AppHeader } from "./components/AppHeader/AppHeader";
import { DraftProvider } from "./contexts/DraftProvider/DraftProvider";
import { api } from "./api/api";
import { useAuth } from "./contexts/AuthProvider/AuthProvider";
import { FileUploadProvider } from "./features/FileUpload/FileUploadProvider";
import { socketService } from "./services/socket";
import { registerSocketEvents } from "./services/socketEvents";
import { EmailWrapper } from "./views/email/EmailWrapper";
import { ChatWidget } from "./components/ChatWidget";
import { GlobalMessagesRender } from "./components/GlobalMessagesRender/GlobalMessagesRender";




function App() {
  const routing = useRoutes(Router);
  const theme = ThemeSettings();
  const ref = React.useRef<DataTableV2ProviderHandle | null>(null);
  const customizer = useSelector(
    (state: IStoreState) => state.customizerReducer
  );
  const { user } = useAuth();

  const getCachingData = async () => {
    try {
      const res = await api.get(
        "/user/get-user-meta-config?user_fact_id=" + user.userId
      );
      if (res.data.data.length > 0) {
        return res.data.data[0]["config_value"];
      }
      return {};
    } catch (err) {
      console.log(err);
      return {};
    }
  };

  const saveCachingData = async (data: any) => {
    try {
      await api.post("/user/create-user-meta-config", {
        user_fact_id: user.userId,
        module_name: "",
        config_value: data,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const getUrlAndProperties = (data: any) => {
    return {
      url:"/user/create-user-meta-config",
      otherParams: data,
    }
  }

    React.useEffect(() => {
    if (user.isLogin && user.tokens ) {
      if(ref.current && ref.current.getCachingConfigFromServerAtLoad){
        ref.current.getCachingConfigFromServerAtLoad();
      }
    }
  }, [user]);


  React.useEffect(() => {
    if (user.isLogin && user.tokens) {
     socketService.connect(user.userId);

    registerSocketEvents();

    return () => {
      socketService.disconnect();
    };
    }
  }, [user]);

  return (
    <>
      <AppHeader />
      <GlobalMessagesRender />
      <ThemeProvider theme={theme}>
        <TableProvider
          tableConfig={{
            stickyHeader: true,
          }}
        >
          <DataTableV2Provider
            ref={ref}
            cachingFilters={{
              enableCaching: true,
              getCachingConfigFromServerAtLoad: getCachingData,
              saveCachingIntoServer: saveCachingData,
              getUrlAndProperties: getUrlAndProperties
            }}
            tableConfig={{ stickyHeader: true }}
          >
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <RTL direction={customizer.activeDir as "ltr"}>
                <FileUploadProvider>
                <DraftProvider>
                  <EmailWrapper>
                    <CssBaseline />
                    {routing}
                    <ChatWidget />
                  </EmailWrapper>
                </DraftProvider>
                </FileUploadProvider>
              </RTL>
            </LocalizationProvider>
          </DataTableV2Provider>
        </TableProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
